import { ContentfulConfigs } from '@vfmfe/foundations';
import { cf } from '../utils/contentful';
import { FooterModelType } from '../types';

/**
 * Fetches the footer data from Contentful using REST API
 */
export default async function getFooter({
    locale,
    preview = false,
    config,
    name
}: {
    locale?: string;
    preview?: boolean;
    config?: ContentfulConfigs;
    name?: string;
} = {}): Promise<FooterModelType | null> {
    const baseParams = {
        content_type: 'footerModel',
        locale,
        include: 10,
        preview
    };

    // Try to fetch by specific analyticsId
    const footerById = await cf<FooterModelType[]>(
        {
            ...baseParams,
            'fields.name': name
        },
        config
    );

    if (footerById && footerById.length > 0) return footerById[0];

    // Fallback to any header/footer of this type
    const anyFooter = await cf<FooterModelType[]>(baseParams, config);

    return anyFooter?.[0] ?? null;
}
